import {
  ModalContent,
  ModalOverlay,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Modal,
  useDisclosure,
} from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button';
import { FormikInput } from 'components/Formik';
import { useFetchPaychexClientInformation } from 'hooks/integrations/useFetchPaychexClientInformation';
import {
  useUpdatePaychexClientInformation,
  IPaychexClientInformation,
} from 'hooks/integrations/useUpdatePaychexClientInformation';

import { initialClientInformationFormData, clientInformationFormValidationSchema } from './schema';

const ClientInformation: React.FC<unknown> = () => {
  const { isOpen: isFormOpen, onOpen: onFormOpen, onClose: onFormClose } = useDisclosure();

  const { t } = useTranslation(['employees', 'integrations', 'common']);

  const { status: clientInformationStatus, data: clientInformationData, refetch } = useFetchPaychexClientInformation();
  const { status: clientInformationSaveStatus, mutateAsync: clientInformationSaveMutateAsync } =
    useUpdatePaychexClientInformation();

  const onClientInformationSave = async (values: typeof initialClientInformationFormData) => {
    const postData: IPaychexClientInformation = {
      client_id: values.client_id,
      regular: values.regular,
      overtime: values.overtime,
      double_overtime: values.double_overtime,
    };
    clientInformationSaveMutateAsync(postData).then(() => {
      refetch();
      onFormClose();
    });
  };

  return (
    <div>
      <Modal isOpen={isFormOpen} onClose={onFormClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t('integrations:quickbooks.settings')}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Formik
              enableReinitialize
              initialValues={clientInformationData?.payload[0]}
              validationSchema={clientInformationFormValidationSchema}
              onSubmit={onClientInformationSave}
            >
              {() => (
                <Form noValidate>
                  <FormikInput
                    type="text"
                    name="client_id"
                    label={t('integrations:paychexCsv.clientId')}
                    formControlProps={{ isRequired: true }}
                  />
                  <FormikInput
                    type="text"
                    name="regular"
                    label={t('integrations:paychexCsv.defaultRegularHoursPayComponent')}
                    formControlProps={{ isRequired: true }}
                  />
                  <FormikInput
                    type="text"
                    name="overtime"
                    label={t('integrations:paychexCsv.defaultOvertimeHoursPayComponent')}
                    formControlProps={{ isRequired: true }}
                  />
                  <FormikInput
                    type="text"
                    name="double_overtime"
                    label={t('integrations:paychexCsv.defaultDoubleOvertimeHoursPayComponent')}
                    formControlProps={{ isRequired: true }}
                  />
                  <Button mr={3} type="submit" isLoading={clientInformationSaveStatus === 'loading'}>
                    {t('common:save')}
                  </Button>
                  <Button onClick={onFormClose} variant="ghost">
                    {t('common:cancel')}
                  </Button>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
      <Button
        colorScheme="secondary"
        mt={{ base: '5', md: '0' }}
        isLoading={clientInformationStatus === 'loading'}
        onClick={onFormOpen}
      >
        {t('integrations:paychexCsv.clientInformation')}
      </Button>
    </div>
  );
};
export default ClientInformation;
